



















































import Vue from "vue";
import EnumPicker from "@/components/picker/EnumPicker.vue";
import { Gender, NationalityType } from "@/scripts/enums";
import { currentStudentBasicInfo, currentStudentIdentityInfo, updateCurrentStudentBasicInfo } from "@/api/my";
import _ from "lodash";
import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers("config");

export default Vue.extend({
    name: "BasicInfoEdit",
    props: {},
    components: { EnumPicker },
    data() {
        return {
            form: {
                name: "",
                englishName: "",
                gender: Gender.MALE,
                phone: "",
                email: "",
                user: {
                    phone: "",
                    englishName: ""
                },
                nationalityType: NationalityType.DOMESTIC
            },
            formRules: {
                required: [{ required: true, message: this.$t("common.error.required") }]
            },
            formErrors: {
                identityNo: ""
            },
            loading: false,
            isForeign: false,
            isInternalUser: true,
            submitDisabled: false
        };
    },
    methods: {
        ...mapActions(["getOrgConfig"]),
        onSubmit() {
            updateCurrentStudentBasicInfo(this.form)
                .then(ignore => {
                    this.$toast(this.$t("common.alert.saveSuccess"));
                    this.$router.back();
                })
                .catch(errors => {
                    _.forEach(errors, error => {
                        if (error.field === "identityNo") {
                            this.formErrors.identityNo = error.message;
                        }
                    });
                });
        }
    },
    computed: {
        ...mapGetters(["orgConfig"]),
        showNationalityType(): boolean {
            if (Object.keys(this.orgConfig).length == 0) {
                return false;
            }
            return !!this.orgConfig["showNationalityType"];
        }
    },
    async mounted() {
        const basicInfoResp = await currentStudentBasicInfo();
        const identityInfoResp = await currentStudentIdentityInfo();
        this.form = { ...basicInfoResp.data.data, ...identityInfoResp.data.data };
        this.$set(this.form, "englishName", this.form.user.englishName);
        this.$set(this.form, "phone", this.form.user.phone);
        this.isForeign = this.form.nationalityType === NationalityType.FOREIGN;
        this.isInternalUser = basicInfoResp.data.data.isInternalUser;
        this.submitDisabled = false;
        await this.getOrgConfig();
    }
});
